<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="班级名称" prop="className">
                <el-input v-model="dataForm.className" placeholder="班级名称" :readonly="true" disabled></el-input>
            </el-form-item>
            <el-form-item label="评价名称" prop="evaluateItemName">
                <el-input v-model="dataForm.evaluateItemName" placeholder="评价项名称" :readonly="true" disabled></el-input>
            </el-form-item>
            <el-form-item label="分数" prop="score">
                <el-input v-model="dataForm.score" placeholder="分数" disabled></el-input>
            </el-form-item>
            <el-form-item label="申诉原因" prop="reason">
                <el-input v-model="dataForm.reason" placeholder="原因" disabled></el-input>
            </el-form-item>
            <el-form-item label="审核状态" prop="state">
                <el-select v-model="dataForm.state" placeholder="请选择" disabled>
                    <el-option label="审核通过" :value=appeal.YES></el-option>
                    <el-option label="审核驳回" :value=appeal.NO></el-option>
                    <el-option label="等待审核" :value=appeal.WAIT></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="审核" v-if="this.dataForm.state === appeal.WAIT ">
                <el-button type="primary" @click="appealUpdateHandle()">通过</el-button>
                <el-button type="danger" @click="appealUpdateNoPassHandle()">不通过</el-button>
            </el-form-item>
            <el-form-item label="审核原因" prop="reason">
                <el-input v-model="dataForm.auditReason" placeholder="审核原因"></el-input>
            </el-form-item>

        </el-form>
        <template slot="footer">
<!--            <el-button @click="closeAndRefresh()">{{ $t('cancel') }}</el-button>-->
<!--            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>-->
            <el-button type="primary" @click="closeAndRefresh">关闭</el-button>
        </template>
        <appeal-update v-if="appealUpdateVisible" ref="appealUpdate" @init="init()"></appeal-update>
    </el-dialog>
</template>
<script>
import debounce from 'lodash/debounce'
import { appeal } from '@/constant'
import AppealUpdate from './appeal-update.vue'

export default {
  data () {
    return {
      appeal,
      visible: false,
      appealUpdateVisible: false,
      appealId: '',
      dataForm: {
        id: '',
        state: '',
        auditReason: ''

      }
    }
  },
  computed: {
    dataRule () {
      return {}
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    appealUpdateHandle () {
      this.appealUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.appealUpdate.appealId = this.appealId
        this.$refs.appealUpdate.appealType = 1
        this.$refs.appealUpdate.init()
      })
    },
    appealUpdateNoPassHandle () {
      this.appealUpdateVisible = true
      this.$nextTick(() => {
        this.$refs.appealUpdate.appealId = this.appealId
        this.$refs.appealUpdate.appealType = 2
        this.$refs.appealUpdate.init()
      })
    },
    add () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        if (this.dataForm.evaluateScoreId) {
          this.getEvaluatescore()
        }
      })
    },
    // 获取信息
    getEvaluatescore () {
      this.$http.get('/classEvaluate/evaluateScore/info/' + this.dataForm.evaluateScoreId).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {
      })
    },

    // 获取信息
    getInfo () {
      this.$http.get('/appeal/appeal/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        this.appealId = this.dataForm.id
        this.getEvaluatescore()
      }).catch(() => {
      })
    },
    closeAndRefresh () {
      this.visible = false
      this.$emit('refreshDataList')
    },

    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        this.dataForm.id = this.appealId
        this.$http[!this.dataForm.id ? 'post' : 'put']('/appeal/appeal/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {
        })
      })
    }, 1000, {
      leading: true,
      trailing: false
    })
  },
  components: {
    AppealUpdate
  }
}
</script>
